const htmlTemplate = htmlWebpackPlugin => {
  const reactDom = '${reactDom}';
  const helmetTitle = '${helmet.title.toString()}';
  const helmetMeta = '${helmet.meta.toString()}';
  const helmetLink = '${helmet.link.toString()}';
  const helmetHtmlAttributes = '${helmet.htmlAttributes.toString()}';
  const helmetBodyAttributes = '${helmet.bodyAttributes.toString()}';
  const reduxStore = 'window.REDUX_DATA = ${JSON.stringify(reduxState)}';

  // place app id
  // appId = `<!--Build_id_${Math.floor(1000 + Math.random() * 9000)}_3+ABkRPTkaMKBPuQ3N2cb4Mu2jwmdbOj3zM+CkfkL3Q=-->`;

  const htmlTemplate = `
             <!DOCTYPE html>
                <html ${helmetHtmlAttributes}">
                <head>
                    <meta charset="utf-8">
                    ${htmlWebpackPlugin.tags.headTags}
                    ${helmetTitle}
                    ${helmetMeta}
                    ${helmetLink}
                </head>
                <!-- Google tag (gtag.js) --> <script async src="https://www.googletagmanager.com/gtag/js?id=G-2L1KFXQC3H"></script> <script> window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-2L1KFXQC3H'); </script>
                
                <body ${helmetBodyAttributes}>
                    <div id="root">${reactDom}</div>
                    <script>${reduxStore}</script>
                    ${htmlWebpackPlugin.tags.bodyTags}
                </body>
                </html>`;

  return `export default (reactDom, reduxState, helmet) => (\`${htmlTemplate}\`);`;
};

module.exports = htmlTemplate;
